import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export default function HeaderSection(props) {
    var _props_bgStyle;
    var containsCentered = (_props_bgStyle = props.bgStyle) === null || _props_bgStyle === void 0 ? void 0 : _props_bgStyle.includes("centered");
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative overflow-hidden px-6 md:px-14 lg:pt-4", {
            "pb-10": !props.logo && props.bgStyle !== "grey_centered",
            "lg:pb-14": !props.logo && !props.videoUrl && props.bgStyle && props.bgStyle !== "plain_centered" && props.bgStyle !== "grey_centered",
            "lg:mt-0 md:pt-0 lg:pt-4 lg:pb-8": !containsCentered && !props.logo && props.bgStyle,
            "pb-0 md:pb-0": props.logo,
            "lg:mb-0 lg:mt-4": props.videoUrl,
            "bg-gray-30 mb-10 !mt-0 md:pb-6 pt-7 md:pt-0": (!props.bgStyle || props.bgStyle === "plain_centered") && !props.logo,
            "pb-0 lg:pb-9": props.bgStyle === "grey_centered"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto max-w-7xl md:relative z-10 md:pt-[5.5rem] pt-10 lg:pt-20", {
            "pt-8": !props.bgStyle,
            "lg:pt-[70px]": props.bgStyle === "grey_centered"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("md:relative lg:flex gap-x-6 xl:gap-x-10", {
            "mx-auto justify-center": containsCentered === true,
            "pb-8 lg:pb-0": !containsCentered && !props.logo && props.bgStyle,
            "justify-between": props.videoUrl,
            "md:pb-11": (!props.bgStyle || props.bgStyle === "plain_centered") && !props.logo
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("relative z-10", {
            "lg:w-[56%]": props.logo,
            "mx-auto": (!props.bgStyle || props.bgStyle === "plain_centered") && !props.logo
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("text-center max-w-4xl", {
            "md:text-left": containsCentered !== true && !props.logo && props.bgStyle && !props.videoUrl,
            "lg:text-left": props.logo || props.videoUrl,
            "mx-auto": containsCentered === true
        })
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-[2rem] leading-tight md:text-5xl lg:text-6xl lg:leading-tight font-heading font-semibold"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "inline-block pb-4"
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.heading,
        classNames: {
            em: "text-orange-500 not-italic"
        }
    }))), props.description && /*#__PURE__*/ React.createElement("p", {
        className: clsx("text-gray-100 text-lg lg:text-xl pb-7 lg:pb-11 inline-block black-links", {
            "md:max-w-xl lg:max-w-2xl xl:max-w-4xl": props.bgStyle && props.bgStyle !== "plain_centered" || props.logo,
            "max-w-4xl": (!props.bgStyle || props.bgStyle === "plain_centered") && !props.logo
        })
    }, /*#__PURE__*/ React.createElement(Html, {
        markup: props.description
    }))), props.cta && props.cta.label && /*#__PURE__*/ React.createElement("div", {
        className: clsx("mb-12 text-center", {
            "md:text-left": !containsCentered && !props.videoUrl || !props.bgStyle && !props.logo,
            "lg:text-left": props.videoUrl
        })
    }, /*#__PURE__*/ React.createElement("a", {
        href: "".concat(props.cta.target),
        className: "button-secondary w-full sm:w-auto border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white"
    }, props.cta.label)), props.ctas ? /*#__PURE__*/ React.createElement("div", {
        className: "block"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("sm:flex justify-center sm:gap-x-4 lg:max-w-xl xl:max-w-full lg:pb-[4.4rem] xl:pb-20", {
            "md:justify-start": !containsCentered && !props.videoUrl,
            "lg:justify-start": props.videoUrl || !containsCentered,
            "mx-auto": containsCentered
        })
    }, props.ctas.map(function(cta, key) {
        /*#__PURE__*/ return React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            id: cta === null || cta === void 0 ? void 0 : cta.label.replace(/\s+|[^A-Za-z0-9]/g, "").toLowerCase(),
            className: clsx("w-full md:w-auto mb-4 md:mb-5 lg:mb-0", {
                "button-secondary focus bg-white border-gray-600 text-gray-600 hover:bg-orange-500 hover:border-orange-500 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY"
            })
        }, cta === null || cta === void 0 ? void 0 : cta.label);
    }))) : null, props.categories ? /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center sm:items-start sm:flex-row sm:gap-x-4 sm:justify-center lg:justify-start"
    }, props.categories.map(function(category, key) {
        /*#__PURE__*/ return React.createElement("span", {
            key: key,
            className: "text-[10px] text-center tracking-wider text-gray-200 font-heading mb-2 px-3.5 py-1 bg-gray-10 rounded-full uppercase inline-block"
        }, category === null || category === void 0 ? void 0 : category.name);
    })) : null), props.videoUrl ? /*#__PURE__*/ React.createElement("div", {
        className: "relative max-[1023px]:mx-auto lg:pb-16 w-full max-w-[680px] lg:max-w-[55%] xl:max-w-[730px] text-center lg:text-left mt-5 md:mt-7 lg:mt-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "rounded-l-2xl border border-gray-300 overflow-hidden relative w-full pb-[56.25%] z-10 inline-block lg:block"
    }, /*#__PURE__*/ React.createElement("iframe", {
        width: "717",
        height: "403",
        src: "".concat(props.videoUrl, "?autoplay=1"),
        title: "Wistia video player",
        allow: "autoplay; encrypted-media",
        allowFullScreen: true,
        className: "max-w-full absolute top-0 left-0 w-full h-full"
    }))) : null, props.logo ? /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-[44%]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "logo-dots-bg mt-5 mx-auto lg:m-0 relative w-[272px] md:w-[670px] lg:w-[545px] h-40 lg:h-[340px]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "absolute top-6 md:top-1.5 inset-x-0 mx-auto lg:m-0 lg:top-[79px] lg:left-[137px] lg:right-[unset] border border-yellow-500 p-3 md:p-7 rounded-full w-28 h-28 md:w-36 md:h-36 lg:w-[178px] lg:h-[178px] text-center bg-white shadow-[0_0_10px_0_rgba(0,0,0,0.1)] flex items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
        className: "max-w-full max-h-[75px]",
        src: "".concat(props.logo.image),
        alt: "".concat(props.logo.label)
    }))))) : null, props.bgStyle === "yellow_centered" && !props.videoUrl ? /*#__PURE__*/ React.createElement(CenteredYellowSvgs, null) : null)), props.bgStyle === "yellow_bottom" ? /*#__PURE__*/ React.createElement(BottomYellowSvg, null) : null, props.bgStyle === "yellow_top" ? /*#__PURE__*/ React.createElement(TopYellowSvg, null) : null, props.bgStyle === "grey_bottom" ? /*#__PURE__*/ React.createElement(BottomGreySvg, null) : null, props.bgStyle === "grey_top" ? /*#__PURE__*/ React.createElement(TopGreySvg, null) : null, props.bgStyle === "grey_centered" ? /*#__PURE__*/ React.createElement(CenteredGreySvg, null) : null);
}
function CenteredYellowSvgs() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "702px",
        height: "841px",
        viewBox: "0 0 702 841",
        version: "1.1",
        className: "knime-hidden md:block absolute bottom-0 md:bottom-[unset] md:-top-[610px] lg:-top-[575px] -left-[300px] lg:-left-[270px] xl:-left-[220px]"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "hero-pattern-bg-centered-ltyellow_desktop",
        transform: "translate(167.000000, 389.000000)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(-166.422649, -388.921109)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,727.773225 L142.252776,0 L701.398552,487.083025 L693.329312,489.853401 L0,727.773225 L0,727.773225 Z M148.649166,18.6375405 L12.9425196,712.916256 L682.061079,483.30405 L148.649166,18.6375405 L148.649166,18.6375405 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M64.2474121,756.383577 L117.939856,165.588165 L602.735346,507.483779 L64.2474121,756.383577 L64.2474121,756.383577 Z M124.623913,180.049229 L73.42981,743.362936 L586.86889,506.04176 L124.623913,180.049229 L124.623913,180.049229 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.579911,784.884736 L93.6784981,331.301008 L503.935809,527.864259 L128.579911,784.884736 L128.579911,784.884736 Z M100.548056,341.334483 L133.83361,773.915776 L491.812394,528.798147 L100.548056,341.334483 L100.548056,341.334483 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192.941784,813.074119 L69.6703269,497.196159 L404.852436,548.371013 L192.941784,813.074119 L192.941784,813.074119 Z M76.2180534,502.437429 L194.207716,804.783584 L397.039575,551.422035 L76.2180534,502.437429 L76.2180534,502.437429 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M256.723052,840.630534 L46.5056847,662.907406 L48.3849474,662.232452 L305.507095,569.704059 L256.723052,840.630534 L256.723052,840.630534 Z M51.0461187,663.727472 L255.160991,836.287235 L302.528723,573.227453 L51.0461187,663.727472 L51.0461187,663.727472 L51.0461187,663.727472 Z",
        id: "Shape"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "702px",
        height: "841px",
        viewBox: "0 0 702 841",
        version: "1.1",
        className: "knime-hidden md:block absolute top-0 md:top-[unset] md:-bottom-[570px] lg:-bottom-[480px] -right-[370px]"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "hero-pattern-bg-centered-ltyellow_desktop",
        transform: "translate(-1065.000000, -68.000000)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(1415.723373, 488.605842) scale(-1, -1) translate(-1415.723373, -488.605842) translate(1065.024097, 68.290575)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,727.773225 L142.252776,0 L701.398552,487.083025 L693.329312,489.853401 L0,727.773225 L0,727.773225 Z M148.649166,18.6375405 L12.9425196,712.916256 L682.061079,483.30405 L148.649166,18.6375405 L148.649166,18.6375405 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M64.2474121,756.383577 L117.939856,165.588165 L602.735346,507.483779 L64.2474121,756.383577 L64.2474121,756.383577 Z M124.623913,180.049229 L73.42981,743.362936 L586.86889,506.04176 L124.623913,180.049229 L124.623913,180.049229 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.579911,784.884736 L93.6784981,331.301008 L503.935809,527.864259 L128.579911,784.884736 L128.579911,784.884736 Z M100.548056,341.334483 L133.83361,773.915776 L491.812394,528.798147 L100.548056,341.334483 L100.548056,341.334483 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192.941784,813.074119 L69.6703269,497.196159 L404.852436,548.371013 L192.941784,813.074119 L192.941784,813.074119 Z M76.2180534,502.437429 L194.207716,804.783584 L397.039575,551.422035 L76.2180534,502.437429 L76.2180534,502.437429 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M256.723052,840.630534 L46.5056847,662.907406 L48.3849474,662.232452 L305.507095,569.704059 L256.723052,840.630534 L256.723052,840.630534 Z M51.0461187,663.727472 L255.160991,836.287235 L302.528723,573.227453 L51.0461187,663.727472 L51.0461187,663.727472 L51.0461187,663.727472 Z",
        id: "Shape"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        className: "md:hidden absolute -top-4 left-0 w-56 h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG",
        transform: "translate(195.000000, 405.000000) scale(1, -1) translate(-195.000000, -405.000000) "
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(-601.000000, 405.500000) scale(1, -1) rotate(-90.000000) translate(601.000000, -405.500000) translate(-1257.000000, -381.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        className: "md:hidden absolute bottom-0 right-0 w-56 h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG",
        transform: "translate(195.000000, 405.000000) scale(1, -1) translate(-195.000000, -405.000000) "
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(992.000000, 405.500000) scale(1, -1) rotate(-270.000000) translate(-992.000000, -405.500000) translate(336.000000, -381.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))));
}
function TopYellowSvg() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "702px",
        height: "841px",
        viewBox: "0 0 702 841",
        version: "1.1",
        className: "knime-hidden md:block absolute -bottom-9 md:-right-80 xl:-right-72 w-[900px] h-auto svg-flip"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "hero-pattern-bg-centered-ltyellow_desktop",
        transform: "translate(167.000000, 389.000000)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(-166.422649, -388.921109)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,727.773225 L142.252776,0 L701.398552,487.083025 L693.329312,489.853401 L0,727.773225 L0,727.773225 Z M148.649166,18.6375405 L12.9425196,712.916256 L682.061079,483.30405 L148.649166,18.6375405 L148.649166,18.6375405 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M64.2474121,756.383577 L117.939856,165.588165 L602.735346,507.483779 L64.2474121,756.383577 L64.2474121,756.383577 Z M124.623913,180.049229 L73.42981,743.362936 L586.86889,506.04176 L124.623913,180.049229 L124.623913,180.049229 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.579911,784.884736 L93.6784981,331.301008 L503.935809,527.864259 L128.579911,784.884736 L128.579911,784.884736 Z M100.548056,341.334483 L133.83361,773.915776 L491.812394,528.798147 L100.548056,341.334483 L100.548056,341.334483 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192.941784,813.074119 L69.6703269,497.196159 L404.852436,548.371013 L192.941784,813.074119 L192.941784,813.074119 Z M76.2180534,502.437429 L194.207716,804.783584 L397.039575,551.422035 L76.2180534,502.437429 L76.2180534,502.437429 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M256.723052,840.630534 L46.5056847,662.907406 L48.3849474,662.232452 L305.507095,569.704059 L256.723052,840.630534 L256.723052,840.630534 Z M51.0461187,663.727472 L255.160991,836.287235 L302.528723,573.227453 L51.0461187,663.727472 L51.0461187,663.727472 L51.0461187,663.727472 Z",
        id: "Shape"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        className: "md:hidden absolute top-0 right-0 w-56 h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(786.000000, 388.500000) scale(1, -1) rotate(-270.000000) translate(-786.000000, -388.500000) translate(130.000000, -398.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4.54747351e-13,1361.81977 L266.090716,-4.94798679e-13 L1312,911.436794 L1296.9061,916.620761 L4.54747351e-13,1361.81977 L4.54747351e-13,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))));
}
function BottomYellowSvg() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "702px",
        height: "841px",
        viewBox: "0 0 702 841",
        version: "1.1",
        className: "knime-hidden md:block absolute -top-10 md:-right-80 xl:-right-64 w-[900px] h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "hero-pattern-bg-centered-ltyellow_desktop",
        transform: "translate(-1065.000000, -68.000000)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(1415.723373, 488.605842) scale(-1, -1) translate(-1415.723373, -488.605842) translate(1065.024097, 68.290575)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,727.773225 L142.252776,0 L701.398552,487.083025 L693.329312,489.853401 L0,727.773225 L0,727.773225 Z M148.649166,18.6375405 L12.9425196,712.916256 L682.061079,483.30405 L148.649166,18.6375405 L148.649166,18.6375405 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M64.2474121,756.383577 L117.939856,165.588165 L602.735346,507.483779 L64.2474121,756.383577 L64.2474121,756.383577 Z M124.623913,180.049229 L73.42981,743.362936 L586.86889,506.04176 L124.623913,180.049229 L124.623913,180.049229 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.579911,784.884736 L93.6784981,331.301008 L503.935809,527.864259 L128.579911,784.884736 L128.579911,784.884736 Z M100.548056,341.334483 L133.83361,773.915776 L491.812394,528.798147 L100.548056,341.334483 L100.548056,341.334483 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192.941784,813.074119 L69.6703269,497.196159 L404.852436,548.371013 L192.941784,813.074119 L192.941784,813.074119 Z M76.2180534,502.437429 L194.207716,804.783584 L397.039575,551.422035 L76.2180534,502.437429 L76.2180534,502.437429 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M256.723052,840.630534 L46.5056847,662.907406 L48.3849474,662.232452 L305.507095,569.704059 L256.723052,840.630534 L256.723052,840.630534 Z M51.0461187,663.727472 L255.160991,836.287235 L302.528723,573.227453 L51.0461187,663.727472 L51.0461187,663.727472 L51.0461187,663.727472 Z",
        id: "Shape"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: "md:hidden absolute -bottom-7 h-auto w-56 right-0"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG",
        transform: "translate(195.000000, 405.000000) scale(1, -1) translate(-195.000000, -405.000000) "
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#F9F3D8",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(786.000000, 388.500000) scale(1, -1) rotate(-270.000000) translate(-786.000000, -388.500000) translate(130.000000, -398.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M-2.27373675e-13,1361.81977 L266.090716,-1.79747534e-13 L1312,911.436794 L1296.9061,916.620761 L-2.27373675e-13,1361.81977 L-2.27373675e-13,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))));
}
function CenteredGreySvg() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1966px",
        height: "1448px",
        viewBox: "0 0 1966 1448",
        version: "1.1",
        className: "absolute -top-[900px] md:-top-[720px] -left-[370px] md:-left-[620px] lg:-left-[520px]"
    }, /*#__PURE__*/ React.createElement("title", null, "BG Pattern"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "-8.61214235e-15",
        y: "0",
        width: "485",
        height: "824"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Thank-You-Page:-Demo",
        transform: "translate(526.000000, 624.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "BG-Pattern",
        transform: "translate(-526.000000, -624.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(500.500000, 600.000000) scale(1, -1) rotate(-360.000000) translate(-500.500000, -600.000000) translate(0.000000, 0.000000)",
        fill: "#F0F2F2",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Pattern",
        transform: "translate(500.500000, 600.000000) scale(1, -1) translate(-500.500000, -600.000000) "
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,1038.8962 L203.015859,0 L1001,695.310968 L989.483995,699.265679 L0,1038.8962 L0,1038.8962 Z M212.144457,26.6050871 L18.4708995,1017.68788 L973.402552,689.91648 L212.144457,26.6050871 L212.144457,26.6050871 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M91.6906078,1079.73748 L168.317706,236.377088 L860.192939,724.433042 L91.6906078,1079.73748 L91.6906078,1079.73748 Z M177.85685,257.020255 L104.795255,1061.15051 L837.549148,722.374559 L177.85685,257.020255 L177.85685,257.020255 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M183.502648,1120.42288 L133.693143,472.932155 L719.191313,753.526174 L183.502648,1120.42288 L183.502648,1120.42288 Z M143.497022,487.254938 L191.000456,1104.76469 L701.889397,754.8593 L143.497022,487.254938 L143.497022,487.254938 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M275.356608,1160.66322 L99.4299133,709.747466 L577.784609,782.799564 L275.356608,1160.66322 L275.356608,1160.66322 Z M108.774492,717.229377 L277.163281,1148.82848 L566.634496,787.154897 L108.774492,717.229377 L108.774492,717.229377 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M366.381959,1200 L66.3705254,946.300253 L69.0525126,945.336757 L436.004041,813.252485 L366.381959,1200 L366.381959,1200 Z M72.8503996,947.470897 L364.152665,1193.79994 L431.75346,818.282129 L72.8503996,947.470897 L72.8503996,947.470897 L72.8503996,947.470897 Z",
        id: "Shape"
    }))))))));
}
function TopGreySvg() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "702px",
        height: "841px",
        viewBox: "0 0 702 841",
        version: "1.1",
        className: "knime-hidden md:block absolute -bottom-9 md:-right-80 xl:-right-72 w-[900px] h-auto svg-flip"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "hero-pattern-bg-centered-ltyellow_desktop",
        transform: "translate(167.000000, 389.000000)",
        fill: "#A8A7A7",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(-166.422649, -388.921109)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,727.773225 L142.252776,0 L701.398552,487.083025 L693.329312,489.853401 L0,727.773225 L0,727.773225 Z M148.649166,18.6375405 L12.9425196,712.916256 L682.061079,483.30405 L148.649166,18.6375405 L148.649166,18.6375405 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M64.2474121,756.383577 L117.939856,165.588165 L602.735346,507.483779 L64.2474121,756.383577 L64.2474121,756.383577 Z M124.623913,180.049229 L73.42981,743.362936 L586.86889,506.04176 L124.623913,180.049229 L124.623913,180.049229 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.579911,784.884736 L93.6784981,331.301008 L503.935809,527.864259 L128.579911,784.884736 L128.579911,784.884736 Z M100.548056,341.334483 L133.83361,773.915776 L491.812394,528.798147 L100.548056,341.334483 L100.548056,341.334483 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192.941784,813.074119 L69.6703269,497.196159 L404.852436,548.371013 L192.941784,813.074119 L192.941784,813.074119 Z M76.2180534,502.437429 L194.207716,804.783584 L397.039575,551.422035 L76.2180534,502.437429 L76.2180534,502.437429 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M256.723052,840.630534 L46.5056847,662.907406 L48.3849474,662.232452 L305.507095,569.704059 L256.723052,840.630534 L256.723052,840.630534 Z M51.0461187,663.727472 L255.160991,836.287235 L302.528723,573.227453 L51.0461187,663.727472 L51.0461187,663.727472 L51.0461187,663.727472 Z",
        id: "Shape"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        className: "md:hidden absolute top-0 right-0 w-56 h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#A8A7A7",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(786.000000, 388.500000) scale(1, -1) rotate(-270.000000) translate(-786.000000, -388.500000) translate(130.000000, -398.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M4.54747351e-13,1361.81977 L266.090716,-4.94798679e-13 L1312,911.436794 L1296.9061,916.620761 L4.54747351e-13,1361.81977 L4.54747351e-13,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))));
}
function BottomGreySvg() {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "702px",
        height: "841px",
        viewBox: "0 0 702 841",
        version: "1.1",
        className: "knime-hidden md:block absolute -top-10 md:-right-80 xl:-right-64 w-[900px] h-auto"
    }, /*#__PURE__*/ React.createElement("title", null, "Angle Pattern"), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "hero-pattern-bg-centered-ltyellow_desktop",
        transform: "translate(-1065.000000, -68.000000)",
        fill: "#A8A7A7",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Angle-Pattern",
        transform: "translate(1415.723373, 488.605842) scale(-1, -1) translate(-1415.723373, -488.605842) translate(1065.024097, 68.290575)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,727.773225 L142.252776,0 L701.398552,487.083025 L693.329312,489.853401 L0,727.773225 L0,727.773225 Z M148.649166,18.6375405 L12.9425196,712.916256 L682.061079,483.30405 L148.649166,18.6375405 L148.649166,18.6375405 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M64.2474121,756.383577 L117.939856,165.588165 L602.735346,507.483779 L64.2474121,756.383577 L64.2474121,756.383577 Z M124.623913,180.049229 L73.42981,743.362936 L586.86889,506.04176 L124.623913,180.049229 L124.623913,180.049229 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M128.579911,784.884736 L93.6784981,331.301008 L503.935809,527.864259 L128.579911,784.884736 L128.579911,784.884736 Z M100.548056,341.334483 L133.83361,773.915776 L491.812394,528.798147 L100.548056,341.334483 L100.548056,341.334483 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M192.941784,813.074119 L69.6703269,497.196159 L404.852436,548.371013 L192.941784,813.074119 L192.941784,813.074119 Z M76.2180534,502.437429 L194.207716,804.783584 L397.039575,551.422035 L76.2180534,502.437429 L76.2180534,502.437429 Z",
        id: "Shape"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M256.723052,840.630534 L46.5056847,662.907406 L48.3849474,662.232452 L305.507095,569.704059 L256.723052,840.630534 L256.723052,840.630534 Z M51.0461187,663.727472 L255.160991,836.287235 L302.528723,573.227453 L51.0461187,663.727472 L51.0461187,663.727472 L51.0461187,663.727472 Z",
        id: "Shape"
    }))))), /*#__PURE__*/ React.createElement("svg", {
        width: "390px",
        height: "810px",
        viewBox: "0 0 390 810",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: "md:hidden absolute -bottom-7 h-auto w-56 right-0"
    }, /*#__PURE__*/ React.createElement("title", null, "Panel BG"), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("rect", {
        id: "path-1",
        x: "0",
        y: "0",
        width: "390",
        height: "810"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Components",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Panel-BG",
        transform: "translate(195.000000, 405.000000) scale(1, -1) translate(-195.000000, -405.000000) "
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask-2",
        fill: "white"
    }, /*#__PURE__*/ React.createElement("use", {
        xlinkHref: "#path-1"
    })), /*#__PURE__*/ React.createElement("g", {
        id: "Panel-Mask"
    }), /*#__PURE__*/ React.createElement("g", {
        id: "Hero-Angle-Pattern",
        mask: "url(#mask-2)",
        fill: "#A8A7A7",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        transform: "translate(786.000000, 388.500000) scale(1, -1) rotate(-270.000000) translate(-786.000000, -388.500000) translate(130.000000, -398.000000)",
        id: "Shape"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M-2.27373675e-13,1361.81977 L266.090716,-1.79747534e-13 L1312,911.436794 L1296.9061,916.620761 L-2.27373675e-13,1361.81977 L-2.27373675e-13,1361.81977 Z M278.055473,34.8748351 L24.2096105,1334.0192 L1275.82832,904.36552 L278.055473,34.8748351 L278.055473,34.8748351 Z",
        transform: "translate(656.000000, 680.909886) scale(-1, 1) translate(-656.000000, -680.909886) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M184.55431,1415.35588 L284.988629,309.850967 L1191.8221,949.610979 L184.55431,1415.35588 L184.55431,1415.35588 Z M297.491483,336.910718 L201.73043,1390.99147 L1162.14313,946.912651 L297.491483,336.910718 L297.491483,336.910718 Z",
        transform: "translate(688.188205, 862.603421) scale(-1, 1) translate(-688.188205, -862.603421) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M434.64842,1468.68766 L369.363634,619.935233 L1136.76983,987.747227 L434.64842,1468.68766 L434.64842,1468.68766 Z M382.213474,638.710015 L444.475717,1448.16238 L1114.09239,989.494733 L382.213474,638.710015 L382.213474,638.710015 Z",
        transform: "translate(753.066731, 1044.311445) scale(-1, 1) translate(-753.066731, -1044.311445) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M785.289127,1521.43604 L554.703889,930.360636 L1181.67828,1026.11976 L785.289127,1521.43604 L785.289127,1521.43604 Z M566.951729,940.168176 L787.657114,1505.92267 L1167.06394,1031.82888 L566.951729,940.168176 L566.951729,940.168176 Z",
        transform: "translate(868.191082, 1225.898337) scale(-1, 1) translate(-868.191082, -1225.898337) "
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M1133.75594,1573 L740.534165,1240.44192 L744.049417,1239.17893 L1225.00886,1066.03847 L1133.75594,1573 L1133.75594,1573 Z M749.027266,1241.97643 L1130.83403,1564.87275 L1219.43767,1072.63149 L749.027266,1241.97643 L749.027266,1241.97643 L749.027266,1241.97643 Z",
        transform: "translate(982.771513, 1319.519233) scale(-1, 1) translate(-982.771513, -1319.519233) "
    })))))));
}
